module.exports = __webpack_public_path__ + "img/safari.e6db3099.png";